module.exports = __webpack_public_path__ + "img/sixpackcarrier63.2bf5fa81.jpg";